import React from 'react';

export const RegulationsIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="currentcolor" />
    <mask
      id="mask0_2070_20894"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="36"
      height="36"
    >
      <circle cx="18" cy="18" r="18" fill="#6A7785" />
    </mask>
    <g mask="url(#mask0_2070_20894)">
      <g filter="url(#filter0_d_2070_20894)">
        <rect x="9" y="9" width="18" height="18" rx="2.25" fill="#6D859C" />
        <rect x="9" y="9" width="18" height="18" rx="2.25" stroke="#F8F9FA" strokeWidth="1.4625" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3932 12.7051H16.1324C15.9719 12.7051 15.818 12.772 15.7046 12.8912C15.5911 13.0103 15.5273 13.1719 15.5273 13.3404C15.5273 13.5089 15.5911 13.6705 15.7046 13.7896C15.818 13.9088 15.9719 13.9757 16.1324 13.9757L23.3932 13.9757C23.5537 13.9757 23.7076 13.9088 23.8211 13.7896C23.9345 13.6705 23.9983 13.5089 23.9983 13.3404C23.9983 13.1719 23.9345 13.0103 23.8211 12.8912C23.7076 12.772 23.5537 12.7051 23.3932 12.7051ZM13.5472 18.105H12.6387C12.4702 18.105 12.3086 18.0381 12.1895 17.9189C12.0704 17.7998 12.0034 17.6382 12.0034 17.4697C12.0034 17.3012 12.0704 17.1396 12.1895 17.0204C12.3086 16.9013 12.4702 16.8344 12.6387 16.8344H13.5472C13.7157 16.8344 13.8773 16.9013 13.9965 17.0204C14.1156 17.1396 14.1826 17.3012 14.1826 17.4697C14.1826 17.6382 14.1156 17.7998 13.9965 17.9189C13.8773 18.0381 13.7157 18.105 13.5472 18.105ZM16.1324 16.8348L23.3932 16.8348C23.5537 16.8348 23.7076 16.9018 23.8211 17.0209C23.9345 17.1401 23.9983 17.3017 23.9983 17.4702C23.9983 17.6387 23.9345 17.8003 23.8211 17.9194C23.7076 18.0385 23.5537 18.1055 23.3932 18.1055L16.1324 18.1055C15.9719 18.1055 15.818 18.0385 15.7046 17.9194C15.5911 17.8003 15.5273 17.6387 15.5273 17.4702C15.5273 17.3017 15.5911 17.1401 15.7046 17.0209C15.818 16.9018 15.9719 16.8348 16.1324 16.8348ZM13.5475 13.9763H12.639C12.4705 13.9763 12.3089 13.9094 12.1897 13.7902C12.0706 13.6711 12.0037 13.5095 12.0037 13.341C12.0037 13.1725 12.0706 13.0109 12.1897 12.8917C12.3089 12.7726 12.4705 12.7057 12.639 12.7057H13.5475C13.716 12.7057 13.8776 12.7726 13.9967 12.8917C14.1159 13.0109 14.1828 13.1725 14.1828 13.341C14.1828 13.5095 14.1159 13.6711 13.9967 13.7902C13.8776 13.9094 13.716 13.9763 13.5475 13.9763ZM23.3932 20.9646H16.1324C15.9719 20.9646 15.818 21.0315 15.7046 21.1507C15.5911 21.2698 15.5273 21.4314 15.5273 21.5999C15.5273 21.7684 15.5911 21.93 15.7046 22.0492C15.818 22.1683 15.9719 22.2352 16.1324 22.2352H23.3932C23.5537 22.2352 23.7076 22.1683 23.8211 22.0492C23.9345 21.93 23.9983 21.7684 23.9983 21.5999C23.9983 21.4314 23.9345 21.2698 23.8211 21.1507C23.7076 21.0315 23.5537 20.9646 23.3932 20.9646ZM13.5472 22.2348H12.6387C12.4702 22.2348 12.3086 22.1678 12.1895 22.0487C12.0704 21.9295 12.0034 21.7679 12.0034 21.5994C12.0034 21.4309 12.0704 21.2694 12.1895 21.1502C12.3086 21.0311 12.4702 20.9641 12.6387 20.9641H13.5472C13.7157 20.9641 13.8773 21.0311 13.9965 21.1502C14.1156 21.2694 14.1826 21.4309 14.1826 21.5994C14.1826 21.7679 14.1156 21.9295 13.9965 22.0487C13.8773 22.1678 13.7157 22.2348 13.5472 22.2348Z"
        fill="#F8F9FA"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2070_20894"
        x="4.89374"
        y="6.01953"
        width="26.2125"
        height="26.2109"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.125" />
        <feGaussianBlur stdDeviation="1.6875" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2070_20894" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2070_20894"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
